import React, { CSSProperties, forwardRef } from 'react';
import { classNames } from '../../../../../helpers/utils';
import styles from '../../../../shared/dnd/TreeItem.module.css';

interface Props {
  clone?: boolean;
  depth: number;
  disableInteraction?: boolean;
  disableSelection?: boolean;
  ghost?: boolean;
  indicator?: boolean;
  indentationWidth: number;
  style: CSSProperties,
  wrapperRef?(node: HTMLLIElement): void;
  children: JSX.Element;
}

const WrapperRowProduct = forwardRef<HTMLDivElement, Props>(
  (
    {
      clone,
      depth,
      disableSelection,
      disableInteraction,
      ghost,
      indentationWidth,
      indicator,
      style,
      wrapperRef,
      children,
      ...props
    },
    ref,
  ) => {

    return (
      <>
        <li
          className={classNames(
            styles.Wrapper,
            clone && styles.clone,
            ghost && styles.ghost,
            indicator && styles.indicator,
            disableSelection && styles.disableSelection,
            disableInteraction && styles.disableInteraction,
          )}
          ref={wrapperRef}
          style={
            {
              '--spacing': `${indentationWidth * depth}px`,
            } as React.CSSProperties
          }
          {...props}
        >
          <div ref={ref} className='w-full h-full relative'>{children}</div>
        </li>
      </>
    );
  },
);

export default WrapperRowProduct;
